import { NgModule } from '@angular/core';
import { CommonModule }  from '@angular/common';
import { HttpModule } from '@angular/http';

import { ImageCropperComponent } from 'ng2-img-cropper';



@NgModule({
  imports: [
    CommonModule,
    HttpModule,
  ],
  declarations: [
    ImageCropperComponent
  ],
  exports: [ImageCropperComponent]
})
export class ImageCropperModule { }